import type { Resource } from '../../';
export const returns_exchangeMode_returnToOrderSummary: Resource = {"default":"Cancel and return to order summary"};
